import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import Select from "react-select";
import CustomDatatableGrid from "../../components/CustomDatatableGrid";
import DropdownWithCustomValuesModal from "../../components/DropdownWithCustomValuesModal";
import { customTableStyles } from "../../assets/CustomTableStyles";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png";

function FeeType() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [customDropdownName, setCustomDropdownName] = useState("");
  const [activityCategoryData, setActivityCategoryData] = useState([]);
  const [activityVenueData, setActivityVenueData] = useState([]);

  const [
    isCustomDropdownValuesModalVisible,
    setIsCustomDropdownValuesModalVisible,
  ] = useState(false);
  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      id: 0,
      name: "",
      feeFrequency: null,
      createdBy: localStorage.getItem("userId"),
      organizationId: organizationId,
    },
  });

  const [feeTypes, setFeeTypes] = useState([]);
  const [feeFrequencyData, setFeeFrequencyData] = useState([]);

  useEffect(() => {
    const fetchFeeTypes = async () => {
      try {
        const response = await get(
          `FeeType/GetFeeTypeByOrganizationIdAsync?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setFeeTypes(response.feeType);
      } catch (error) {
        console.error("Error fetching feeType:", error);
      }
    };

    fetchFeeTypes();
  }, [triggerRerender]);

  const fetchCommonSettings = async (moduleName, setData) => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=${moduleName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(response?.commonSettingDetail);
    } catch (error) {
      console.error(`Error fetching ${moduleName}:`, error);
    }
  };

  useEffect(() => {
    fetchCommonSettings("feeFrequency", setFeeFrequencyData);
  }, [token]);

  // const fetchFeeFrequencys = async () => {
  //   try {
  //     const response = await get(
  //       `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=feeFrequency`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     setFeeFrequencyData(response?.commonSettingDetail);
  //   } catch (error) {
  //     console.error("Error fetching centers:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchFeeFrequencys();
  // }, []);

  const columns = [
    {
      accessorKey: "mrt-row-numbers",
      header: "Sr No.",
      enableColumnOrdering: false,
      enableEditing: false,
      enableSorting: false,
      size: 80,
      Cell: ({ row }) => row.index + 1,
    },
    {
      header: "Name",
      accessorKey: "name",
      // size: 200,
    },
    {
      header: "Fee Frequency",
      accessorKey: "feeFrequency",
    },
    {
      id: "actions",
      header: "Action",
      size: 120,
      Cell: ({ row }) => (
        <button
          type="button"
          className="btn p-0"
          onClick={() => handleEditClick(row.original.id)}
        >
          <i className="fas fa-pencil"></i>
        </button>
      ),
    },
  ];

  const exportToExcel = () => {
    const filteredData = feeTypes.map((row, index) => ({
      "Sr No": index + 1,
      Name: row.name,
      "Fee Frequency": row.feeFrequency,
    }));

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "FeeTypes");
    XLSX.writeFile(workbook, "FeeTypes.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const logoWidth = 30;
    const logoHeight = 8;
    const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 10;
    // doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "Fee Types List";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = logoY + logoHeight + 10;
    doc.text(title, titleX, titleY);

    const headers = [["Sr No", "Name", "Fee Frequency"]];

    const bodyData = feeTypes.map((row, index) => [
      index + 1,
      row.name,
      row.feeFrequency,
    ]);

    doc.autoTable({
      head: headers,
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
      },
    });

    doc.save("FeeTypes.pdf");
  };

  const handleEditClick = async (rowId) => {
    const singleFeeType = await get(
      `FeeType/GetFeeTypeByIdAsync?feeTypeId=${rowId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const singleFeeTypeData = singleFeeType.feeType;

    const selectedFeeFrequency = feeFrequencyData.find(
      (frequency) => frequency.id === singleFeeTypeData.feeFrequencyId
    );

    reset({
      id: singleFeeTypeData.id,
      name: singleFeeTypeData.name,
      feeFrequency: {
        value: selectedFeeFrequency?.id || "",
        label: selectedFeeFrequency?.value || "",
      },
      // feeFrequency: singleFeeTypeData.feeFrequency,
      organizationId: singleFeeTypeData.organizationId,
      code: singleFeeTypeData.code,
      createdBy: singleFeeTypeData.createdBy,
      updatedBy: localStorage.getItem("userId"),
    });
  };
  const handleCustomDropdownSetting = (dropdownName) => {
    setCustomDropdownName(dropdownName);
    setIsCustomDropdownValuesModalVisible(true);
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const formData = {
      ...data,
      feeFrequencyId: data.feeFrequency.value,
      feeFrequency: null,
    };

    try {
      const response = await post("FeeType/AddUpdateFeeTypeAsync", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        reset({
          id: 0,
          name: "",
          feeFrequency: null,
          createdBy: localStorage.getItem("userId"),
          organizationId: organizationId,
        });
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Fee Type</h2>
      </div>

      <form className="row g-3 " onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6 new-form-style">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label form-label-new">
                    Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`name`, {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("name")}
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </div>
                <div className="col-md-5">
                  <label className="form-label form-label-new">
                    Fee Frequency<span className="text-danger fs-9">*</span>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="w-100">
                      <Controller
                        name="feeFrequency"
                        control={control}
                        rules={{ required: "This field is required." }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={feeFrequencyData.map((frequency) => ({
                              value: frequency.id,
                              label: frequency.value,
                            }))}
                            onChange={(selectedOption, actionMeta) => {
                              if (actionMeta.action === "clear") {
                                setValue("feeFrequency", null);
                              } else {
                                setValue("feeFrequency", selectedOption);
                              }
                              trigger("feeFrequency");
                            }}
                            className="react-select-style"
                            classNamePrefix="react-select-style-pref"
                            isClearable
                          />
                        )}
                      />
                      {errors.feeFrequency && (
                        <small className="text-danger">
                          {errors.feeFrequency.message}
                        </small>
                      )}
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-outline-primary px-2 lh-1"
                        onClick={() =>
                          handleCustomDropdownSetting("feeFrequency")
                        }
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <CustomDatatableGrid
                columns={columns}
                data={feeTypes}
                onExportExcel={exportToExcel}
                onExportPDF={exportToPDF}
                initialState={{ columnPinning: { right: ["actions"] } }}
              />
            </div>
          </div>
        </div>
      </form>

      {isCustomDropdownValuesModalVisible && (
        <DropdownWithCustomValuesModal
          dropdownName={customDropdownName}
          onClose={() => {
            setIsCustomDropdownValuesModalVisible(false);
            if (customDropdownName === "feeFrequency") {
              fetchCommonSettings("feeFrequency", setFeeFrequencyData);
            }
          }}
        />
      )}
    </>
  );
}

export default FeeType;
